import React from "react";
import EquipoHospitalario from "./EquiposSeccionG/EquipoHospitalario";
import EquipoHospitalizacion from "./EquiposSeccionG/EquipoHospitalizacion";
import EquipoUrgencias from "./EquiposSeccionG/EquipoUrgencias";
import EquipoCuidados from "./EquiposSeccionG/EquipoCuidados";
import EquipoCirugia from "./EquiposSeccionG/EquipoCirugia";
import EquipoSangre from "./EquiposSeccionG/EquipoSangre";
import EquipoImagenes from "./EquiposSeccionG/EquipoImagenes";
import EquipoAmbulatorio from "./EquiposSeccionG/EquipoAmbulatorios";
import EquipoConsultaExterna from "./EquiposSeccionG/EquipoConsultaExterna";
import EquipoOncologia from "./EquiposSeccionG/EquipoOncologia";
import EquipoMejoramiento from "./EquiposSeccionG/EquipoMejoramiento";
import EquipoTerapias from "./EquiposSeccionG/EquipoMejoramientoTerapias";
import EquipoRehabilitacionCardiaca from "./EquiposSeccionG/EquipoRehabilitacionCardiaca";
import EquipoSaludMental from "./EquiposSeccionG/EquipoSaludMental";
import EquipoOdontologiaGeneral from "./EquiposSeccionG/EquipoOdontologiaGeneral";
import EquipoOdontologiaEspecializada from "./EquiposSeccionG/EquipoOdontologiaEspecializada";
import EquipoCirugiaAmbulatoria from "./EquiposSeccionG/EquipoCirugiaAmbulatoria";
import EquipoImagenesTerapeuticas from "./EquiposSeccionG/EquipoImagenesTerapeuticas";
import EquipoPatologia from "./EquiposSeccionG/EquipoPatologia";

function Titulo1SeccionG() {
  return (
    <div>
      <div>
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <EquipoHospitalario />
          </div>
        </div>
        <div>
          <h6 class="m-0 font-weight-bold text-primary">
            Subtítulo: 1.1.1 Equipos primarios de mejoramiento de los servicios
            hospitalarios
          </h6>
          <div>
            Relacione los integrantes de los Equipos Primarios de Mejoramiento
            que apoyan al Equipo de Autoevaluación Hospitalario en la
            implementación, mantenimiento y mejoramiento de los estándares de
            acreditación en los diferentes servicios hospitalarios. En caso de
            contar con otros equipos de apoyo relaciónelos con el nombre de sus
            integrantes, en tablas adicionales que conserven la estructura
            anexandolas a continuación:
          </div>
          <input type="file" name="files" />
        </div>

        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoUrgencias />
        </div>

        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoHospitalizacion />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoCuidados />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoCirugia />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoSangre />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoImagenes />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          {/*Sedes integradas Red */}
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          {/*Gestión Clínica y Seguridad del Paciente*/}
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          {/*Gestión Clínica y Seguridad del Paciente*/}
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoAmbulatorio />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoConsultaExterna />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoOncologia />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoMejoramiento />
        </div>
        <div>
          <h6 class="m-0 font-weight-bold text-primary">
            Subtítulo: 1.2.2 Equipos primarios de mejoramiento de servicios de
            rehabilitación
          </h6>
          <div>
            Relacione el líder y los integrantes de los equipos que apoyan al
            equipo de autoevaluación y mejoramiento hospitalario y ambulatorio
            en la implementación, mantenimiento y mejoramiento de los estándares
            de acreditación en los diferentes servicios de rehabilitación.
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoTerapias />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoRehabilitacionCardiaca />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoSaludMental />
        </div>
        <div>
          <h6 class="m-0 font-weight-bold text-primary">
            Subtítulo: 1.2.3 Equipos primarios de mejoramiento de Odontología
          </h6>
          <div>
            Relacione el líder y los integrantes de los equipos que apoyan al
            equipo de autoevaluación y mejoramiento ambulatorio y hospitalario
            según corresponda, en la implementación, mantenimiento y
            mejoramiento de los estándares de acreditación en los diferentes
            servicios de odontología.
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoOdontologiaGeneral />
        </div>
        <div class="card-body">
          <div class="table-responsive"></div>
          <EquipoOdontologiaEspecializada />
        </div>
        <div>
          <h6 class="m-0 font-weight-bold text-primary">
            Subtítulo: 1.2.4 Equipo primario de mejoramiento de Cirugía
            ambulatoria
          </h6>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive"></div>
        <EquipoCirugiaAmbulatoria />
      </div>
      <div>
        <h6 class="m-0 font-weight-bold text-primary">
          Subtítulo: 1.2.5 Equipos primarios de mejoramiento de Imágenes
          diagnósticas y terapéuticas
        </h6>
        <div>
          Relacione el líder y los integrantes de los Equipos Primarios de
          Mejoramiento que apoyan al Equipo de Autoevaluación Ambulatorio en la
          implementación, mantenimiento y mejoramiento de los estándares de
          acreditación en los diferentes servicios de imágenes diagnósticas y
          terapéuticas.
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive"></div>
        <EquipoImagenesTerapeuticas />
      </div>
      <div>
        <h6 class="m-0 font-weight-bold text-primary">
          Subtítulo: 1.2.6 Equipos primarios de mejoramiento de servicios de
          laboratorio clínico, banco de sangre y patología
        </h6>
        <div>
          Relacione el líder y los integrantes de los equipos que apoyan al
          Equipo de Autoevaluación Ambulatorio en la implementación,
          mantenimiento y mejoramiento de los estándares de acreditación en los
          diferentes servicios de laboratorio clínico.
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive"></div>
        {/**Equipo primario de mejoramiento de Laboratorio y Banco de Sangre */}
      </div>
      <div class="card-body">
        <div class="table-responsive"></div>
        <EquipoPatologia />
      </div>
    </div>
  );
}

export default Titulo1SeccionG;
